"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@material/ripple/dist/mdc.ripple.css");
